import React from "react"
import { Link } from "react-router-dom"
import styled from "styled-components"

const CategoryListView = () => {
  const data = [ {
    subCatName: 'Board Games',
    path: 'boardgames'
},
{
    subCatName: 'PC Games',
    path: 'pcgames'
},
{
    subCatName: 'Console Games',
    path: 'consolegames'
}]

  return (
    <>
      <CatWrap>
        <Box>
          <Heading>Games</Heading>
          {
            data.map((item, index) => {
              return (
                <Item key={index} to={`/productlist/:${item.path}`}>{item.subCatName}</Item>
              )
            })
          }
        </Box>
        <Box>
        <Heading>Consoles</Heading>

          <Item to="#">Nothing</Item>
        </Box>
        <Box>
        <Heading>Geographical Area</Heading>

          <Item to="#">Nothing</Item>
        </Box>
      </CatWrap>
    </>
  )
}

export default CategoryListView

const CatWrap = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-evenly;
  margin: 1rem 0;
`
const Box = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 15rem;
  min-height: 20rem;
  background: #19202aE1;
  align-items: center;
  padding: 1rem 0.2rem;
  border-radius: 5px;
`
const Item = styled(Link)`
  display: flex;
  background: ${({ theme }) => theme.background};
  max-height: 2rem;
  width: 8rem;
  margin: 0.5rem 0;
  border-radius: 5px;
  padding: 0.5rem 1rem;
  text-decoration: none;
  color: ${({ theme }) => theme.text};

  :hover {
    color: ${({ theme }) => theme.accent};
  }
`
const Heading  = styled.div`
  font-size: 1.5rem;
  font-weight: 500;
  color: ${({theme}) => theme.text};
`


